import api from '../../plugins/api';

// Ручной отказ Береке — отправляет applicationContinue с ИИН клиента
const berekeManualReject = (sourceId) => {
  return api.post(`/api/bank/bereke/manualReject?sourceId=${encodeURIComponent(sourceId)}`);
};

export default berekeManualReject;
